"use client";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";

function createData(name, required, datatype, max, desc) {
  return { name, required, datatype, max, desc };
}

const rows = [
  createData("CompanyName", true, "Alphanumeric", 60, "Contact's company name"),
  createData("NickName", false, "Alphabet", 10, "Contact's nick Name"),
  createData(
    "MobileNo",
    true,
    "Numeric",
    10,
    "Contact company's mobile number"
  ),
];

export default function Parameters(props) {
  const [headers, setHeaders] = useState([]);

  useEffect(() => {
    if (props.data) {
      const keysOfMaxKeysObject = getMaxKeys(props.data);

      setHeaders(keysOfMaxKeysObject);
    }
  }, [props.data]);

  // Function to find the keys of the object with the maximum keys
  const getMaxKeys = (arr) => {
    // Find the object with the maximum keys
    let maxKeysObject = arr.reduce((maxObj, currentObj) => {
      return Object.keys(currentObj).length > Object.keys(maxObj).length
        ? currentObj
        : maxObj;
    }, {});

    // Extract and return the keys of that object
    return Object.keys(maxKeysObject);
  };

  return (
    <TableContainer className="data-table" component={Paper}>
      <Table sx={{ width: "100%" }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {headers
              .filter((e) => e !== "required")
              .map((parameter, index) => {
                return (
                  <TableCell key={parameter} className="label-caps">
                    {parameter.split("_").join(" ")}
                  </TableCell>
                );
              })}
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.data?.map((row, index) => (
            <TableRow
              key={row.name}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              {headers
                .filter((e) => e !== "required")
                .map((parameter, index) => {
                  return (
                    <TableCell
                      key={parameter}
                      id={
                        parameter === "parameter"
                          ? "name"
                          : parameter === "data_type"
                          ? "data-type"
                          : parameter === "max_length"
                          ? "length"
                          : parameter === "description"
                          ? "desc"
                          : parameter === "error_code"
                          ? "error"
                          : "desc"
                      }
                    >
                      {row[parameter]}
                      {parameter === "parameter" && row.required && (
                        <span id="required">required</span>
                      )}
                    </TableCell>
                  );
                })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
